var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c("studip-dialog", {
    attrs: {
      title: _vm.$gettext("Teilnehmende hinzufügen"),
      confirmText: _vm.$gettext("Hinzufügen"),
      confirmClass: "accept",
      confirmDisabled: !_vm.taskSolverType,
      closeText: _vm.$gettext("Abbrechen"),
      closeClass: "cancel",
      width: "700",
    },
    on: {
      close: _vm.onClose,
      confirm: _vm.onConfirm,
    },
    scopedSlots: _vm._u([
      {
        key: "dialogContent",
        fn: function fn() {
          return [
            _c(
              "form",
              {
                staticClass: "default",
              },
              [
                _c("label", [
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.$gettext("Verteilen an")) +
                      "\n                "
                  ),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.taskSolverType,
                          expression: "taskSolverType",
                        },
                      ],
                      on: {
                        change: function change($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.taskSolverType = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                      },
                    },
                    [
                      _c(
                        "option",
                        {
                          attrs: {
                            value: "users",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$gettext("Studierende")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "option",
                        {
                          attrs: {
                            value: "status-groups",
                          },
                        },
                        [_vm._v(_vm._s(_vm.$gettext("Gruppen")))]
                      ),
                    ]
                  ),
                ]),
                _vm._v(" "),
                _vm.taskSolverType === "users"
                  ? [
                      _c("CoursewareCompanion", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.autor_members.length === 0,
                            expression: "autor_members.length === 0",
                          },
                        ],
                        attrs: {
                          msgCompanion: _vm.$gettext(
                            "Es wurden keine Studierenden in dieser Veranstaltung gefunden."
                          ),
                          mood: "pointing",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "table",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.autor_members.length > 0,
                              expression: "autor_members.length > 0",
                            },
                          ],
                          staticClass: "default",
                        },
                        [
                          _c("thead", [
                            _c("tr", [
                              _c("th"),
                              _vm._v(" "),
                              _c("th", [_vm._v(_vm._s(_vm.$gettext("Name")))]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(_vm.autor_members, function (user) {
                              return _c(
                                "tr",
                                {
                                  key: user.user_id,
                                },
                                [
                                  _c("td", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.selectedAutors,
                                          expression: "selectedAutors",
                                        },
                                      ],
                                      attrs: {
                                        type: "checkbox",
                                        disabled: _vm.isSolver(user.user_id),
                                        "aria-label": _vm.$gettextInterpolate(
                                          _vm.$gettext("%{userName} auswählen"),
                                          {
                                            userName: user.formattedname,
                                          },
                                          true
                                        ),
                                      },
                                      domProps: {
                                        value: user.user_id,
                                        checked: Array.isArray(
                                          _vm.selectedAutors
                                        )
                                          ? _vm._i(
                                              _vm.selectedAutors,
                                              user.user_id
                                            ) > -1
                                          : _vm.selectedAutors,
                                      },
                                      on: {
                                        change: function change($event) {
                                          var $$a = _vm.selectedAutors,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = user.user_id,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.selectedAutors =
                                                  $$a.concat([$$v]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.selectedAutors = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.selectedAutors = $$c
                                          }
                                        },
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [
                                    _vm._v(_vm._s(user.formattedname)),
                                  ]),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      ),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.taskSolverType === "status-groups"
                  ? [
                      _c("CoursewareCompanion", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.groups.length === 0,
                            expression: "groups.length === 0",
                          },
                        ],
                        attrs: {
                          msgCompanion: _vm.$gettext(
                            "Es wurden keine Gruppen in dieser Veranstaltung gefunden."
                          ),
                          mood: "pointing",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "table",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.groups.length > 0,
                              expression: "groups.length > 0",
                            },
                          ],
                          staticClass: "default",
                        },
                        [
                          _c("thead", [
                            _c("tr", [
                              _c("th"),
                              _vm._v(" "),
                              _c("th", [
                                _vm._v(_vm._s(_vm.$gettext("Gruppenname"))),
                              ]),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            _vm._l(_vm.groups, function (group) {
                              return _c(
                                "tr",
                                {
                                  key: group.id,
                                },
                                [
                                  _c("td", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.selectedGroups,
                                          expression: "selectedGroups",
                                        },
                                      ],
                                      attrs: {
                                        type: "checkbox",
                                        disabled: _vm.isSolver(group.id),
                                        "aria-label": _vm.$gettextInterpolate(
                                          _vm.$gettext(
                                            "%{groupName} auswählen"
                                          ),
                                          {
                                            groupName: group.name,
                                          },
                                          true
                                        ),
                                      },
                                      domProps: {
                                        value: group.id,
                                        checked: Array.isArray(
                                          _vm.selectedGroups
                                        )
                                          ? _vm._i(
                                              _vm.selectedGroups,
                                              group.id
                                            ) > -1
                                          : _vm.selectedGroups,
                                      },
                                      on: {
                                        change: function change($event) {
                                          var $$a = _vm.selectedGroups,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = group.id,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.selectedGroups =
                                                  $$a.concat([$$v]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.selectedGroups = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.selectedGroups = $$c
                                          }
                                        },
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("td", [_vm._v(_vm._s(group.name))]),
                                ]
                              )
                            }),
                            0
                          ),
                        ]
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }